import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAdminPermissions } from "../../apis/dashboardApis";
import { ParentPermission } from "../../apis/dashboardApis";

interface PermissionsState {
  permissions: Set<string>;
  loading: boolean;
  error: string | null;
}

const initialState: PermissionsState = {
  permissions: new Set(),
  loading: false,
  error: null,
};

export const fetchAdminPermissions = createAsyncThunk(
  "permissions/fetchAdminPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAdminPermissions();

      const perms = new Set<string>();

      res.data.forEach((parent: ParentPermission) => {
        parent.childPermissions.forEach((child) => {
          perms.add(`${parent.parentName}.${child.name}`);
        });
      });

      return Array.from(perms); // Set is not serializable
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch permissions");
    }
  },
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = new Set(action.payload);
      })
      .addCase(fetchAdminPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default permissionsSlice.reducer;
